// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Wp-z","selected":"Xp-z"};